import { render, staticRenderFns } from "./user-areas.vue?vue&type=template&id=f31367c0&"
import script from "./user-areas.vue?vue&type=script&lang=js&"
export * from "./user-areas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports